<template>
  <div>
     <div class="petition-counter" v-if="showcounter">
      <h2>
        <count-to ref="counter" :startVal='startcounter' :end-val='endcounter' :autoplay=false :duration='7000' @callbackCounter='updatePercentage'></count-to>
      </h2>
      <h5>{{countertitle}}</h5>
    </div>
    <div class="petition-progressbar" v-if="showprogressbar">
     <progressbar :percentage='percentage' :revdirection='revdirection'></progressbar>
   </div>

    <div v-if="isActive" class="petition-form wwf-form light">
      <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
        <div class="petition-form">
  
          <p class="form-intro">
            <strong>{{title}}</strong>
          </p>
  
          <p class="form-intro">
            <div v-html="intro"></div>
          </p>
  
          <input type="button" value="Here's the message we're sending" v-on:click="openReadLetterPage" class="read-letter" v-if="!seeMessageButtonBottom"/>
  
          <div>
              <input name="firstName" type="text" v-model="firstName" v-validate="{ required: true}" :class="{'border-red': errors.has('firstName')}" placeholder="First name" autocomplete="given-name">
              <input name="lastName" type="text" v-model="lastName" v-validate="{ required: true}" :class="{'border-red': errors.has('lastName')}" placeholder="Last name" autocomplete="family-name">
 
              <input 
                name="email" 
                type="email" 
                v-model="email" 
                v-validate="{ required: true, petitionEmailIsValid: true, email: true}" 
                :class="{'border-red': errors.has('email')}" 
                placeholder="Email" 
                @input="checkEmail()"
              >

              <span class="wwf-alert">
                <p v-if="errors.firstByRule('email')">{{errors.first('email')}}</p>
              </span>
  
              <!-- POST CODE -->
              <input 
                v-if="!hidepostcode && extraMandatoryFields.indexOf('postCode')==-1" 
                name="postCode" 
                :type="(country == 'Australia') ? 'number' : 'text'" 
                v-model="postCode" 
                placeholder="Postcode" 
                @input="postcodeUpdated()"
                >
              <input 
                v-if="!hidepostcode && extraMandatoryFields.indexOf('postCode')>-1" 
                name="postCode" 
                :type="(country == 'Australia') ? 'number' : 'text'" 
                v-model="postCode" 
                placeholder="Postcode" 
                @input="postcodeUpdated()" 
                v-validate="{ required: true, petitionPostCodeIsValid: true }" 
                :class="{'border-red': errors.has('postCode')}"
                >

              <span class="wwf-alert">
                <p v-if="errors.firstByRule('postCode','petitionPostCodeIsValid') || errors.firstByRule('postCode')">{{errors.first('postCode')}}</p>
              </span>
  
              <!-- PHONE NUMBER -->
              <input 
                v-if="showphonenumber && extraMandatoryFields.indexOf('phoneNumber') == -1 && manatoryFields.indexOf('phoneNumber') == -1"
                name="phoneNumber"
                type="tel"
                v-model="phoneNumber"
                placeholder="Phone Number (optional)"
              >
              <input 
                v-if="showphonenumber && (extraMandatoryFields.indexOf('phoneNumber') > -1 || manatoryFields.indexOf('phoneNumber') > -1)"
                name="phoneNumber"
                type="tel"
                v-model="phoneNumber"
                placeholder="Phone Number (required)"
                v-validate="{ required: true }"
                :class="{'border-red': errors.has('phoneNumber')}"
              >

              <span class="wwf-alert">
                <p v-if="errors.firstByRule('phoneNumber')">{{ errors.first('phoneNumber') }}</p>
              </span>
  
                <select v-if="showstate" name="state" v-model="state" v-validate="'required'" :class="{'border-red': errors.has('state')}" placeholder="State">
                <option value="">State</option>
                <option value="ACT">ACT</option>
                <option value="NSW">NSW</option>
                <option value="NT">NT</option>
                <option value="QLD">QLD</option>
                <option value="TAS">TAS</option>
                <option value="VIC">VIC</option>
                <option value="SA">SA</option>
                <option value="WA">WA</option>
                <option value="Outside Australia">Outside Australia</option>              
              </select>

              <!-- Recipients list -->
              <div class="recipients-list" v-if="showrecipientslist && recipients != null">
                <div class="recipients-title">You will be contacting</div>

                <!-- Main Recipient -->
                <div class="recipient" v-if="recipients.mainMP">• {{ recipients.mainMP.salutation }} {{ recipients.mainMP.name }}</div>

                <!-- Senator -->
                <div class="recipient" v-if="recipients.senator">• {{ recipients.senator.salutation }} {{ recipients.senator.name }}</div>

                <!-- MP -->
                <!-- Multiple MPs -->
                <div class="mps-list" v-if="recipients.mps.length > 1">
                  <div>Select your MP</div>
                  <div class="wwf-radio-bttns mp-item">
                    <label :for="'mp-' + mp.email" v-for="mp in recipients.mps">
                      <input
                        type="radio"
                        v-validate="'required'"
                        v-model="selectedMP"
                        name="selectedMP"
                        :value="mp"
                        :id="'mp-' + mp.email"
                      />
                      {{ mp.salutation }} {{ mp.name }}, MP
                      <span class="wwf-radio"></span>
                    </label>
                  </div>
                </div>

                <!-- Single MP -->
                <div class="recipient" v-if="recipients.mps.length === 1 && selectedMP != null">• {{ selectedMP.salutation }} {{ selectedMP.name }}, MP</div>
              </div>

              <textarea v-if="showmessage" name="message" :placeholder="messageplaceholder" v-model="message" maxlength="255" :class="{'border-red': errors.has('message')}"></textarea>
              <p v-if="showmessage" class="word-count">{{ 255 - (message ? message.length : 0) + ' Char' }}</p>

              <select v-if="showcountry" name="country" v-model="country" v-validate="'required'" :class="{'border-red': errors.has('country')}" autocomplete="country" placeholder="Country">
                <option v-for="(countries, index) in countriesList" :value="countries.name">{{countries.name}}</option>
              </select>

              <input 
                type="button"
                class="read-letter"
                value="Here's the message we're sending"
                v-on:click="openReadLetterPage"
                v-if="seeMessageButtonBottom"
              />
              
             <div v-if="showpermission">
                  Do you give permission for your submission to be published on the EPBC Act Review website?</br>
                  <input type="radio" name="permissionyes" id="permissionyes" v-validate="'required'" value="Yes" v-model="permission" :class="{'border-red': errors.has('permissionyes')}">
                  <label for="permissionyes">Yes – with my name</label></br>
                  <input type="radio" name="permissionanonymous" id="permissionanonymous" v-validate="'required'" value="Anonymous" v-model="permission" :class="{'border-red': errors.has('permissionyes')}">
                  <label for="permissionanonymous">Yes – anonymously </label></br>
                  <input type="radio" name="permissionno" id="permissionno" v-validate="'required'" value="No" v-model="permission" :class="{'border-red': errors.has('permissionyes')}">
                  <label for="permissionno">No – please keep my submission confidential</label>
                </div>

            
              <div v-for="(extracampaign, index) in getextracampaignsList">
                <input type="checkbox" :name="'extracampaign' + index" :id="'extracampaign' + index" :value="extracampaign"  v-model="selectedCampaign">
                <label :for="'extracampaign' + index">Add my name to {{ extracampaign.title }} too!</label>
              </div>

            <div class="privacy-statement">
              <p>By signing you accept
                <a href="/privacy-policy/privacy-policy" target="_blank">WWF-Australia&rsquo;s Privacy Policy.</a>
              </p>
            </div>
            <input type="button" class="btn-submit" v-on:click="save()" :disabled="isSaving" :value="isSaving ? 'Loading...' : 'Submit'" />
  
            <span class="alert-box" v-show="isProfanity">No bad words! Please change your message.</span>
          </div>
  
        </div>
      </div>
  
    </div>
  
 <div v-if="!isActive" class="form-closed">
      <p>{{closingmessage}}</p>
    </div>

  </div>
</template>

<script>
import { Validator } from "vee-validate";
import countTo from "vue-count-to";
import progressbar from "./Progressbar.vue";

const { detect } = require('detect-browser');
const browser = detect();
import {
  getCountriesList,
  getAustralianStateByPostcode
} from "../helpers";

export default {
  components: { countTo, progressbar },
  name: "my-petitionForm",
  created: function() {

    // Define some mandatory fields with the query params
    let uri = window.location.search.substring(1);
    if (uri.length > 0) {
      let params = new URLSearchParams(uri);
      const typeParam = params.get("type");
      this.queryCampaign = typeParam ? typeParam : '';

      if (this.queryCampaign.includes('epbc')) {
        this.manatoryFields.push('phoneNumber');
      }
    }

    if (this.showcounter || this.showprogressbar) {
      this.$store.dispatch("getCounterByCampaignId", this.datalayername);
    }

    // Check the email
    let petitionEmailIsValid = email => {
      if (!this.isEmailValid) {
        return {
          valid: false,
          data: { message: "The email has already been submitted" }
        };

      } else {
        return {
          valid: true
        };
      }
    };

    Validator.extend("petitionEmailIsValid", {
      validate: petitionEmailIsValid,
      getMessage: (field, params, data) => data.message
    });

    // Check the postcode
    let petitionPostCodeIsValid = postCode => {
      if (this.restrictedPostcode && (!this.state || this.state.length === 0)) {
        return {
          valid: false,
          data: { message: "Please enter a postcode between 0000 and 9999" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    Validator.extend("petitionPostCodeIsValid", {
      validate: petitionPostCodeIsValid,
      getMessage: (field, params, data) => data.message
    });
  },
  mounted: function() {    
    if (this.showcounter) {
      console.log(this.$refs.counter);
      this.$refs.counter.start();
    }
    
    // Fetch the content of the messages
    if (this.lettermessage) {
      this.$store.dispatch('getContentMessageById', this.lettermessage).then(value => {
        if (value) {
          this.letterContent = this.formatMessageContent(value.content)
        } else {
          this.letterContent = '';
        }
        this.selectedFixedMessage = this.letterContent;
      });
    }

    if (this.lettermessages) {
      const values = Object.values(this.lettermessages);
      const calls = [];
      for (const v of values) {
        calls.push(this.$store.dispatch('getContentMessageById', v));
      }
      Promise.all(calls).then(response => {
        // only use valid item
        response = response.filter(e => e);        

        this.letterContents = {};
        for (const s of Object.keys(this.lettermessages)) {
          const contentId = this.lettermessages[s];
          const content = response.find(e => e.id === contentId);

          // Display empty if the content do not exist
          if (content) {
            this.letterContents[s] = this.formatMessageContent(content.content);
          } else {
            this.letterContents[s] = '';
          }
        }
      })
      .catch(err => {
        this.letterContents = {};
        console.error(err);
      });
    }
  },
  computed: {
    endcounter: function() {
      return this.$store.getters.counter
        ? this.$store.getters.counter
        : 0;
    },
    getextracampaignsList:function(){
      console.log("getextracampaignsList");
      let extracampaignsList = [];
      for( let i=0;i<this.extracampaigns.length;i++){
        let array = this.extracampaigns[i].split("|");
        let obj = {name:array[0],datalayer:array[1],title:array[2]};
        extracampaignsList.push(obj);        
      }
      console.log(extracampaignsList);
      return extracampaignsList;
    }
  },
  watch: {
    // use the watch to react on the value change.
    endcounter(newValue) {
      if (this.showcounter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
        console.log("endcounter:newValue", newValue);  
      }      
    }
  },
  props: { 
    limit:{
       type: Number,
       default: 1000
    },
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    title: {
      //thankyoutitle="Test title"
      type: String,
      required: true
    },
    intro: {
      //intro="Test intro"
      type: String,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test thankyou title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test thankyou message"
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    extracampaigns: {
      // program Name | datalyer | title
      type: Array,
      required: false,
      default: () => []
    },
    showcounter: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    showprogressbar: {
      type: Boolean,
      default: false
    },
    revdirection:{
      type: Boolean,
      default: false
    },
    countertitle: {
      //countertitle="Test message sent"
      type: String,
      default: "message sent"
    },
    messageplaceholder: {
      //countertitle="Test message placeholder"
      type: String,
      default: "Message"
    },
    lettertitle: {
      //lettertitle="Test letter title"
      type: String,
      required: true
    },
    lettermessage: {
      //lettermessage="Test letter message"
      type: String,
      required: false
    },
    lettermessages: {
      //lettermessage="Test letter message"
      type: Object,
      required: false
    },
    keepData: {
      type: Boolean,
      default: false
    },
    scheduledLead: {
      type: Boolean,
      default: false
    },
    showmessage: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    showcountry: {
      //showcounter="true"
      type: Boolean,
      default: false
    },
    extraMandatoryFields: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: () => []
    },
    showstate: {
      //showstate="true"
      type: Boolean,
      default: false
    },
    useState: {
      type: Boolean,
      default: false
    },
    showpermission: {
      //showpermission="true"
      type: Boolean,
      default: false
    },
    hidepostcode: {
      //hidepostcode="true"
      type: Boolean,
      default: false
    },
    productIds: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: () => []
    },
    automaticStateUpdate: {
      type: Boolean,
      default: false
    },
    seeMessageButtonBottom: {
      type: Boolean,
      default: false
    },
    stateDependentButtons: {
      type: Boolean,
      default: false
    },
    restrictedPostcode: {
      type: Boolean,
      default: false
    },
    showphonenumber: {
      type: Boolean,
      default: false
    },
    showrecipientslist: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      percentage:0,
      startcounter: 0,
      selectedCampaign:[],
      firstName: '',
      lastName: '',
      email: '',
      postCode: '',
      phoneNumber: '',
      country:'Australia',
      message: '',
      isLoading: false,
      error: false,
      isProfanity: false,
      isFlip: false,
      isCollapse: false,
      isShake: false,
      newmintarget: this.mintarget,
      countriesList: getCountriesList(),
      permission: '',
      state:'',
      selectedFixedMessage: null,
      isEmailValid: false,
      letterContent: null,
      letterContents: null,
      queryCampaign: '',
      manatoryFields: [],
      recipients: null,
      selectedMP: null,
      timeout: null,
      isSaving: false
    }
  },
  methods: {
    formatMessageContent(content) {
      return `<style> .letter-content { text-align:left; border: 4px double #c1c1c1; padding: 25px; } .letter-content p { margin: 1em; text-align: left !important; } </style> <div class="letter-content">${content}</div>`;
    },
    updateMessage: function() {
      if (this.letterContents && this.state) {
        this.selectedFixedMessage = this.letterContents[this.state];
      }
    },
    postcodeUpdated: function() {
      this.updateState();
      if (this.postCode && this.postCode.toString().length >= 3) {
        this.updateRecipients();
      }
    },
    updateRecipients: function() {
      if (this.showrecipientslist) {        
        this.$store.dispatch("getEPBCRecipients", { postcode: this.postCode })
          .then(result => {
            if (result) {
              this.recipients = result;
              if (this.recipients.mps) {
                this.selectedMP = this.recipients.mps[0];
              }
            }
          })
      }
    },
    updateState: function() {
      if (this.automaticStateUpdate && this.postCode && this.postCode.toString().length >= 3) {
        const state = getAustralianStateByPostcode(this.postCode);
        if (state && this.state != "Outside Australia") {
          this.state = state;
          this.updateMessage();
          this.errors.remove('postCode');
        }
      } else if (this.automaticStateUpdate) {
        // if this.automaticStateUpdate is true but the postcode is not valid, reset the state
        this.state = '';
      }
    },
    checkEmail: function() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(() => {
        this.$store.dispatch("checkEmail", {
          campaignId: this.datalayername,
          email: this.email
        }).then(result => {
          if (result) {
            this.errors.add({
              field: 'email',
              msg: "Your email has already been submitted"
            });
            this.isEmailValid = false;
          } else {
            this.errors.remove('email');
            this.isEmailValid = true;
          }
        });
      }, 500);
    },
    updatePercentage: function(e,t) {
      this.percentage = (e*100)/this.limit
    },
    openReadLetterPage: function() {
      if (this.stateDependentButtons && (!this.state || this.state.length === 0)) {
        this.errors.add({
          field: 'postCode',
          msg: "Please enter a valid Postcode between 0000 and 9999"
        });
        return;
      } else {
        this.errors.remove('postCode');
      }

      if (!this.selectedFixedMessage) {
        if (this.letterContents) {
          if (this.state) {
            this.selectedFixedMessage = this.letterContents[this.state];
          } else {
            const keys = Object.keys(this.letterContents);
            this.selectedFixedMessage = this.letterContents[keys[0]];
          }
        }
      }

      this.$emit("openthankyoupopup", [
        this.lettertitle,
        this.selectedFixedMessage,
        false,
        false
      ]);
    },
    save: function() {
      // Exit the function if it's busy
      if (this.isSaving) { return; }
      this.isSaving = true;
      
      if ((this.showstate || this.useState) && (!this.state || this.state.length === 0)) {
        this.updateState();
        if (!this.state || this.state.length === 0) {
          this.errors.add({
            field: 'postCode',
            msg: "Please enter a valid Postcode between 0000 and 9999"
          });
          this.isSaving = false;
          return;
        }

      } else {
        this.errors.remove('postCode');
      }

      let epbc = null;
      if (this.recipients) {
        epbc = {
          mp: this.selectedMP,
          senator: this.recipients.senator,
          mainMP: this.recipients.mainMP
        }
      }
    
    var postBody = {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      postcode: (!this.hidepostcode) ? this.postCode : null,
      programName: this.programname,
      message: this.message ? this.message : "",
      cookieID: this.$cookie.get("_mkto_trk"),
      keepData: this.keepData,
      scheduledLead: this.scheduledLead,
      country : (this.showcountry) ? this.country : ((this.showstate) ? ((this.state=='Outside Australia') ? this.state : 'Australia') : null),
      permission: (this.showpermission) ? this.permission : null,
      state : (this.showstate || this.useState) ? ((this.state=='Outside Australia') ? '' : this.state) : null,
      country : (this.state=='Outside Australia') ? this.state : 'Australia',
      phone: this.phoneNumber,
      isPhoneNumberMandatory: (this.extraMandatoryFields && this.extraMandatoryFields.indexOf('phoneNumber') > -1) 
        || (this.manatoryFields && this.manatoryFields.indexOf('phoneNumber') > -1),

      epbc: epbc
    };

    if (browser) {
      postBody.browsername = browser.name
      postBody.browserversion = browser.version
      postBody.browseros = browser.os
    }

    console.log(postBody);

      this.$validator.validate().then(result => {
        if (result) {
          if(this.showmessage)
          {
            this.$http
            .jsonp(
              "https://api1.webpurify.com/services/rest/?api_key=b7c6af7e5259ce74f099897deb9dcf29&method=webpurify.live.check&text=" +
                encodeURIComponent(postBody.message) +
                "&format=json"
            )
            .then(response => {
              if (response.data) {
                this.isProfanity = response.data.rsp.found != "0";
                if (!this.isProfanity) {
                  console.log("Message clean");
                  this.saveLead(postBody)
                } else {
                  console.log("Message not clean");
                  this.isSaving = false;
                }
              } else {
                this.isSaving = false;
              }
            });
          }
          else
          {
            this.saveLead(postBody)
          }
        } 
        else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: this.datalayername,
              event: "formSubmitEvent"
            });
          }
          this.isSaving = false;
          this.isShake = true;
          setTimeout(
            function() {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
    saveLead: function(postBody) {
                    this.$store
                    .dispatch("saveLead", {
                      campaignId: this.datalayername,
                      lead: postBody
                    })
                    .then(
                      response => {
                        console.log("petition submit success");

                        if (window.dataLayer != undefined) {
                          window.dataLayer.push({
                            formName: this.datalayername,
                            event: "formSubmitSuccessEvent"
                          });
                        }


                        
                  this.selectedCampaign.forEach(element => {
                      postBody.programName = element.name

                    this.$store
                    .dispatch("saveLead", {
                      campaignId: element.datalayer,
                      lead: postBody
                    })
                    .then(
                      response => {
                        console.log("petition submit success");

                        if (window.dataLayer != undefined) {
                          window.dataLayer.push({
                            formName: element.datalayer,
                            event: "formSubmitSuccessEvent"
                          });
                        }
                      },
                      error => {
                        console.error("Petition submit failed");
                      }
                    );
                  });


                        //Reset form
                        this.firstName = "";
                        this.lastName = "";
                        this.email = "";
                        this.postCode = "";
                        this.message = "";
                        this.country = "Australia";
                        this.checked = false;
                        this.state = "";
                        this.permission = "";
                        this.phoneNumber = "";
                        this.recipients = null;
                        this.selectedMP = null;
                        this.isSaving = false;
                      },
                      error => {
                        console.error("Petition submit failed");
                        this.isSaving = false;
                      }
                    ).catch(err => {
                      console.error("Petition submit failed");
                      this.isSaving = false;
                    });


                  console.log('openthankyoupopup', this.productIds)

                  this.$emit("openthankyoupopup", [
                    this.thankyoutitle,
                    this.thankyoumessage,
                    true,
                    false,
                    "donate-rg-form",
                    {
                      productIds: this.productIds,
                      emailprefill: postBody.email,
                      currentpage: true,
                      dollarhandleclick: false
                    }
                  ]);
    }
  }
};
</script>

<style lang="css" scoped>
.petition-progressbar
{
    width: 100%;
    display: inline-block;
    top: -90px;
    position: relative;
}
.petition-progressbar + .petition-form{
  position: relative;
  top: -90px;
}

span.wwf-alert {
  position: absolute;
  display: block;
  text-align: left;
  width: 100%;
  pointer-events: none;
  z-index: 9;
}

span.wwf-alert p {
  position: relative;
  background-color: #ff003b;
  left: 0;
  top: -18px;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  padding: 5px 10px;
  line-height: normal;
  border-radius: 3px;
  color: white;
  font-size: 13px;
  box-shadow: 0 3px 13px rgba(0,0,0,0.2);
  z-index: 10;
  font-weight: 600;
}

.recipients-list {
  padding: .5rem;
  margin: 0 0 1rem;
  background-color: rgba(0,0,0,.05);
  color: #222;
}

.recipients-title {
  margin: 0 0 5px;
}

.recipient {
  margin: 0 0 0 10px;
}

.mps-list {
  margin: 5px 0 0 10px;
}

.mp-item {
  margin: 0 0 0 15px;
}

.mp-item input {
  margin-bottom: 5px;
}

.btn-submit:disabled {
  background-color: rgba(0, 0, 0, .2) !important;
}
</style>


// WEBPACK FOOTER //
// petitionForm.vue?e5f0c99e